<template>
  <div>
    <div class="ticket-description" tabindex="0" v-if="productGroups.description">
      {{ productGroups.description }}
    </div>
    <all-products :products="productGroups.products"
                  :productUserCount="productGroups.concurrency_count"
                  :productColor="productColor"
                  :productGroupNum="productGroupNum"
                  :voucher-type="voucherType"
                  :current-index="currentIndex"
                  :key="'product'+currentIndex"
                  :is-oksusu="isOksusu"
                  :current-product-name="currentProductName"
                  :voucher-name="voucherName"
    />
  </div>
</template>

<script>
import AllProducts from '@/components/voucher/AllProducts'

export default {
  components: {
    AllProducts
  },
  props: {
    productGroups: {
      type: Object,
      required: true
    },
    categoryNum: {
      type: Number,
      required: true
    },
    productGroupNum: {
      type: String,
      required: true
    },
    voucherType: {
      type: String,
      required: true
    },
    currentIndex: {
      type: String
    },
    isOksusu: {
      type: Boolean
    },
    currentProductName: {
      type: String
    },
    voucherName: {
      type: String
    }
  },
  data () {
    return {
      productColor: '#fff'
    }
  }
}
</script>
